import React, { useEffect, useState } from 'react';
import { AppLayout } from '@/components/AppLayout';
import { LayoutDashboard, Users, Building2, Wallet, UserCog, Trash2 , ScrollText } from 'lucide-react';

import { adminApi } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { TID } from '@/constants/testIds';
import { Loader } from '@/components/Loader';

const links = [
  { to: '/admin', end: true, label: 'Tableau de bord', icon: LayoutDashboard },
  { to: '/admin/bailleurs', label: 'Bailleurs', icon: Building2 },
  { to: '/admin/locataires', label: 'Locataires', icon: Users },
  { to: '/admin/agents', label: 'Agents', icon: UserCog },
  { to: '/admin/abonnements', label: 'Abonnements', icon: Wallet },
  { to: '/admin/catalogue', label: 'Paramètres', icon: UserCog },
  { to: '/admin/audit', label: 'Audit', icon: ScrollText },
];

export default function AdminLocataires() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = async () => {
    setLoading(true);
    try {
      const { data } = await adminApi.listLocataires();
      setItems(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (l) => {
    if (!window.confirm(`Supprimer ${l.prenom} ${l.nom} ?`)) return;
    await adminApi.deleteLocataire(l.id);
    toast.success('Locataire supprimé');
    load();
  };

  return (
    <AppLayout links={links} testid={TID.adminSidebar} title="Tous les locataires">
      <div className="lb-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr className="text-left">
                {['Locataire', 'Logement', 'Loyer', 'Bailleur', ''].map((h) => (
                  <th key={h} className="px-4 py-3 text-[11px] font-semibold uppercase tracking-widest text-slate-500">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={5} className="px-4 py-8"><Loader variant="full" /></td></tr>}
              {!loading && items.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-500">Aucun locataire.</td></tr>
              )}
              {items.map((l) => (
                <tr key={l.id} className="border-b border-slate-100 hover:bg-slate-50/60">
                  <td className="px-4 py-3">
                    <div className="font-semibold text-[#0D1B2A]">{l.prenom} {l.nom}</div>
                    <div className="text-xs text-slate-500">{l.telephone}</div>
                  </td>
                  <td className="px-4 py-3 text-slate-700">{l.adresse_logement}</td>
                  <td className="px-4 py-3 font-semibold text-[#0D1B2A]">{l.montant_loyer} {l.devise}</td>
                  <td className="px-4 py-3 text-slate-700">{l.bailleur ? `${l.bailleur.prenom} ${l.bailleur.nom}` : '—'}</td>
                  <td className="px-4 py-3 text-right">
                    <Button variant="ghost" size="icon" className="text-red-600 hover:text-red-700" onClick={() => remove(l)}>
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AppLayout>
  );
}
